import axios from 'axios'
import httpConfig from "../core/config/config";
import {Message, Loading} from 'element-ui';
import storage from "../core/utils/storage";
import router from "../router/route";
import Date from "../core/utils/date";
import Config from "../core/config/config";

let loadingInstance = null; //这里是loading
let loadingInstanceTimeId = 0; //这里是loading
//使用create方法创建axios实例
export const Service = axios.create({
    timeout: 60000, // 请求超时时间
    baseURL: httpConfig.getBaseUrl(),
    method: 'post',
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
});
// 添加请求拦截器
Service.interceptors.request.use(config => {
    if (!loadingInstanceTimeId) {
        loadingInstanceTimeId = setTimeout(() => {
            loadingInstance = Loading.service({
                lock: true,
                text: 'loading...'
            });
        }, 3000);
    }
    config.headers.Authorization = storage.get('token');
    config.headers.lang = storage.get('lang');
    config.headers.timestamp = Date.getUtcTick();
    config.headers.timeZone = storage.get('zone');
    //config.headers.version = httpConfig.pcVersion;//管理端版本号
    config.headers.version = Config.getPCVersion();//管理端版本号
    config.headers.client = 'PC';//管理端版本号

    //console.log('版本号：', appInfo.getPCVersion());
    return config
});
// 添加响应拦截器
Service.interceptors.response.use(response => {
    if (loadingInstanceTimeId) {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
        clearTimeout(loadingInstanceTimeId);
        loadingInstanceTimeId = 0;
    }
    let res = response.data;
    if (res.code !== 'success') {
        if (res.code === 'authorization' || res.code === 'kickOff') {
            if (response.config.url !== '/menu/get/show' || res.code === 'kickOff') {
                Message({
                    message: res.message,
                    type: 'error',
                    duration: 3 * 1000
                });
            }
            storage.delete("userData");
            storage.delete("token");
            storage.delete("userType");
            storage.delete("userId");
            router.push({
                path: "/login"
            });
        } else {
            Message({
                message: res.message,
                type: 'error',
                duration: 3 * 1000
            });
        }
    }

    return response.data
}, error => {
    // console.log('TCL: error', error);
    const msg = error.Message !== undefined ? error.Message : '';
    Message({
        message: '网络错误' + msg,
        type: 'error',
        duration: 3 * 1000
    });
    if (loadingInstanceTimeId) {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
        clearTimeout(loadingInstanceTimeId);
        loadingInstanceTimeId = 0;
    }
    return Promise.reject(error)
});